import {qspost, qspostfile} from '@/plugins/axios'

/*
 * 获取老年人认证审核列表
 * @constructor jack
 * */
export const getShenheList = (page, pageSize) => qspost('/Index/Jumin/getOldJuminShenhe', {page, pageSize})

/*
 * 老年人认证审核通过
 * @constructor jack
 * */
export const getShenheYes = (id) => qspost('/Index/Jumin/OldJuminShenhePass', {id})

/*
 * 老年人认证审核拒绝
 * @constructor jack
 * */
export const getShenheNo = (id, remark) => qspost('/Index/Jumin/OldJuminShenhejujue', {id, remark})


/*
 * 服务人员列表
 * @constructor jack
 * */
export const getServicePeople = () => qspost('/Index/Jumin/getServicePeople', {})


/*
 * 人员删除
 * @constructor jack
 * */
export const delServicePeople = (id) => qspost('/Index/Jumin/delServicePeople', {id})


/*
 * 人员添加
 * @constructor jack
 * */
export const addServicePeople = (name, phone, wordage, beizhu) => qspost('/Index/Jumin/addServicePeople', {
  name,
  phone,
  wordage,
  beizhu
})


/*
 * 人员修改
 * @constructor jack
 * */
export const updateServicePeople = (id, name, phone, wordage, beizhu) => qspost('/Index/Jumin/updateServicePeople', {
  id,
  name,
  phone,
  wordage,
  beizhu
})


/*
 * 服务统计
 * @constructor jack
 * */
export const getJuminService = () => qspost('/Index/Jumin/getJuminService', {})

/*
 * 服务统计
 * @constructor jack
 * */
export const getNewJuminService = (xiangmuId) => qspost('/Index/Newjumin/getJuminService', {xiangmuId})


/*
 * 服务列表
 * @constructor jack
 * */
export const xiaoquServiceList = (name, phone, xiangmu_id, xiaoqu_id, lou_id, men_id, hu_id, service_type, state, comment, page, pageSize, startTime,
                                  endTime
) => qspost('/Index/Jumin/xiaoquServiceList', {
  name,
  phone,
  xiangmu_id,
  xiaoqu_id,
  lou_id,
  men_id,
  hu_id,
  service_type,
  state,
  comment,

  page,
  pageSize,
  startTime,
  endTime,
})

/*
 * 服务列表导出
 * */
export const authXiaoquServiceList = (name, phone, xiangmu_id, xiaoqu_id, lou_id, men_id, hu_id, service_type, state, comment,startTime,
                                  endTime
) => qspost('/index/export/exportXiaoquServiceList', {
  name,
  phone,
  xiangmu_id,
  xiaoqu_id,
  lou_id,
  men_id,
  hu_id,
  service_type,
  state,
  comment,
  startTime,
  endTime,
})

export const exportXiaoquServiceList = (name, phone, xiangmu_id, xiaoqu_id, lou_id, men_id, hu_id, service_type, state, comment,startTime,
                                  endTime
) => qspostfile('/index/export/exportXiaoquServiceList', {
  name,
  phone,
  xiangmu_id,
  xiaoqu_id,
  lou_id,
  men_id,
  hu_id,
  service_type,
  state,
  comment,
  startTime,
  endTime,
})


/*
 * 导出服务居民数据
 * */
export const exportJuminService = () => qspostfile('/index/export/exportJuminService', {
})

/*
 * 服务备注
 * @constructor jack
 * */
export const beizhuServiceOrder = (id, desc) => qspost('/Index/Jumin/beizhuServiceOrder', {
  id, desc
})

/*
 * 删除进行中、已完成服务
 * @constructor jack
 * */
export const delIngProjectService = (id) => qspost('/Index/Newjumin/delServiceOrder', {
  id
})

/*
 * 按钮
 * */
export const confirmServiceOrder = (id) => qspost('/Index/Newjumin/confirmServiceOrder', {
  id
})

/*
 * 修改服务类别
 * */
export const updateServiceType = (id,service_type) => qspost('/Index/Jumin/updateServiceType', {
  id,service_type
})

/*
 * 一键设置兑换数量，兑换时间，是否限制兑换数量
 * @constructor jack
 * */
export const fastUpdateProduct = (xiangmu_id,is_limit,exchange_num,exchange_start_time,exchange_end_time) => qspost('/Index/Product/fastUpdateProduct', {
  xiangmu_id,is_limit,exchange_num,exchange_start_time,exchange_end_time
})


/*
 * 获取服务分类下的服务类目
 * @constructor jack
 * */
export const projectServiceList = (cate) => qspost('/Index/Service/projectServiceList', {
  cate
})

/*
 * 添加、修改服务类目
 * @constructor jack
 * */
export const addProjectService = (cate, content, score, id) => qspost('/Index/Service/addProjectService', {
  cate, content, score, id
})
/*
 * 删除服务类目
 * @constructor jack
 * */
export const delProjectService = (id) => qspost('/Index/Service/delProjectService', {
  id
})


/*
 * 被服务人员列表
 * @constructor jack
 * */
export const getServedPeople = (name, phone, xiangmu_id, xiaoqu_id, lou_id, men_id, hu_id, page, pageSize) => qspost('/Index/Service/getServedPeople', {
  name, phone, xiangmu_id, xiaoqu_id, lou_id, men_id, hu_id, page, pageSize
})

/*
 * 被服务人员详情
 * @constructor jack
 * */
export const getServedPeopleDetail = (jumin_id, page, pageSize) => qspost('/Index/Service/getServedPeopleDetail', {
  jumin_id, page, pageSize
})

/*
 * 被服务人员积分修改
 * @constructor jack
 * */
export const updateServedIntegral = (jumin_id, num, reason) => qspost('/Index/Service/updateServedIntegral', {
  jumin_id, num, reason
})


/*
 * 志愿者队长/居民队员列表
 * @constructor jack
 * */
export const getWuyeguanjiaList = (name, phone, power, page, pageSize) => qspost('/Index/Service/getWuyeguanjiaList', {
  name, phone, power, page, pageSize
})

/*
 * 志愿者队长/居民队员详情
 * @constructor jack
 * */
export const getWuyeguanjiaDetail = (id, page, pageSize) => qspost('/Index/Service/getWuyeguanjiaDetail', {
  id, page, pageSize
})

/*
 * 被服务人员积分修改
 * @constructor jack
 * */
export const updateServiceIntegral = (admin_id, num, reason, type) => qspost('/Index/Service/updateServiceIntegral', {
  admin_id, num, reason, type
})


/*
 * 被服务人员积分修改
 * @constructor jack
 * */
export const resetJinnuanbao = (name, phone, power) => qspost('/Index/Service/resetJinnuanbao', {name, phone, power})


/*
 * 积分查看服务明细
 * @constructor jack
 * */
export const getServiceDetial = (id) => qspost('/Index/Service/getServiceDetial', {
  id
})
/*
 * 积分查看服务明细
 * @constructor jack
 * */
export const getAdminServiceDetial = (id) => qspost('/Index/Service/getAdminServiceDetial', {
  id
})


/*
 * 居民队员的家庭成员列表
 * @constructor jack
 * */
export const getJiatingMember = (id) => qspost('/Index/Service/getJiatingMember', {
  id
})
/*
 * 居民队员的家庭成员审核
 * @constructor jack
 * */
export const exJiatingMember = (id, state, reason) => qspost('/Index/Service/exJiatingMember', {
  id, state, reason
})

/*
 * 居民队员的家庭成员删除
 * @constructor jack
 * */
export const delJiatingMember = (id) => qspost('/Index/Service/delJiatingMember', {
  id
})


/*
 * 商品列表
 * @constructor jack
 * */
export const productList = (xiangmu_id,name, show, type, page, pageSize, searchTime = '', startTime = '', endTime = '') => qspost('/Index/Product/productList', {
  xiangmu_id,name, show, type, page, pageSize, searchTime, startTime, endTime
})

/*
 *   商品兑换记录
 * @constructor jack
 * */
export const productOrder = (xiangmu_id,state,start_time,end_time,page, pageSize) => qspost('/Index/Product/productOrder', {
  xiangmu_id,state,start_time,end_time,page, pageSize
})

/*
 *   商品兑换记录
 * @constructor jack
 * */
export const exportProductOrder = (xiangmu_id,state,start_time,end_time) => qspostfile('/Index/Export/exportProductOrder', {xiangmu_id,state,start_time,end_time
})

/*
 *   操作记录
 * @constructor jack
 * */
export const productLog = (product_id,page, pageSize) => qspost('/Index/Product/productLog', {
  product_id,page, pageSize
})

/*
 *   操作记录
 * @constructor jack
 * */
export const exportProductLog = (product_id) => qspostfile('/Index/Export/exportProductLog', {
  product_id
})
/*
 * 商品删除
 * @constructor jack
 * */
export const delProduct = (id) => qspost('/Index/Product/delProduct', {
  id
})

/*
 * 商品添加
 * @constructor jack
 * */
export const addProduct = (type,xiangmu_id, name, price, num, exchange_num, exchange_start_time, exchange_end_time, images, content, id = '') => qspost('/Index/Product/addProduct', {
  type,xiangmu_id, name, price, num, exchange_num, exchange_start_time, exchange_end_time, images, content, id
})

/*
 * 商品详情
 * @constructor jack
 * */
export const productDetail = (id) => qspost('/Index/Product/productDetail', {
  id
})

/*
 * 1加库存 2减库存
 * */
export const setProductNum = (product_id,type,num) => qspost('/Index/Product/setProductNum', {
  product_id,type,num
})


/*
 *  商品在项目的库存列表
 * */
export const productXiangmuNumList = (product_id,page, pageSize) => qspost('/index/product/productXiangmuNumList', {
  product_id,page, pageSize
})

/*
 * 增加商品在项目的库存
 * */
export const addProductXiangmuNum = (product_id,xiangmu_id,num) => qspost('/index/product/addProductXiangmuNum', {
  product_id,xiangmu_id,num
})

/*
 * 增加减少商品在项目的库存
 * */
export const setProductXiangmuNum = (id,type,num) => qspost('/index/product/setProductXiangmuNum', {
  id,type,num
})

/*
 * 删除商品在项目的库存
 * */
export const delProductXiangmuNum = (id) => qspost('/index/product/delProductXiangmuNum', {
  id
})



/*
 * 订单列表
 * @constructor jack
 * */
export const orderList = (product_name, page, pageSize, name, searchTime = '', startTime = '', endTime = '') => qspost('/Index/Product/orderList', {
  product_name, name, page, pageSize, searchTime, startTime, endTime
})

/*
 * 商品订单发货/取消
 * @constructor jack
 * */
export const updateState = (id, state) => qspost('/Index/Product/updateState', {
  id, state
})

/*
 * 居民标签列表
 * @constructor jack
 * */
export const juminTagList = () => qspost('/Index/Jumin/juminTagList', {})

/*
 * 居民标签添加
 * @constructor jack
 * */
export const addJuminTag = (name, id) => qspost('/Index/Jumin/addJuminTag', {name, id})

/*
 * 居民标签添加
 * @constructor jack
 * */
export const addNewJuminTag = (xiangmu_id,name, id) => qspost('/Index/Newjumin/addJuminTag', {xiangmu_id,name, id})


/*
 * 居民标签删除
 * @constructor jack
 * */
export const delJuminTag = (id) => qspost('/Index/Jumin/delJuminTag', {id})

/*
 * 获取积分倍数
 * @constructor jack
 * */
export const getInregralLv = () => qspost('/Index/Service/getInregralLv', {})

/*
 * 设置积分倍数
 * @constructor jack
 * */
export const updateInregralLv = (
  wygj_integral,
  wygj_jinnuanbao,
  wygj_yinnuanbao,
  sndy_integral,
  sndy_jinnuanbao,
  sndy_yinnuanbao,
  lmz_integral,
  lmz_jinnuanbao,
  lmz_yinnuanbao,
  wyyg_integral,
  wyyg_jinnuanbao,
  wyyg_yinnuanbao,
  jm_integral,
  jm_jinnuanbao,
  jm_yinnuanbao,
  shzz_integral,
  shzz_jinnuanbao,
  shzz_yinnuanbao,
  integral_lv,fcmy_lv, my_lv, yb_lv, bmy_lv
) => qspost('/Index/Service/updateInregralLv', {
  wygj_integral,
  wygj_jinnuanbao,
  wygj_yinnuanbao,
  sndy_integral,
  sndy_jinnuanbao,
  sndy_yinnuanbao,
  lmz_integral,
  lmz_jinnuanbao,
  lmz_yinnuanbao,
  wyyg_integral,
  wyyg_jinnuanbao,
  wyyg_yinnuanbao,
  jm_integral,
  jm_jinnuanbao,
  jm_yinnuanbao,
  shzz_integral,
  shzz_jinnuanbao,
  shzz_yinnuanbao,
  integral_lv,fcmy_lv, my_lv, yb_lv, bmy_lv
})





/*
 * 项目服务列表
 * @constructor jack
 * */
export const getProjectServiceList = () => qspost('/Index/Newservice/projectServiceList', {})

/*
 * 添加服务
 * @constructor jack
 * */
export const addNewProjectService = (id,name,score) => qspost('/Index/Newservice/addProjectService', {id,name,score})

/*
 * 删除服务
 * @constructor jack
 * */
export const delNewProjectService = (id) => qspost('/Index/Newservice/delProjectService', {id})

/*
 * 获取服务分类
 * @constructor jack
 * */
export const getProjectServiceCate = () => qspost('/Index/Service/getProjectServiceCate', {})

/*
 * 获取服务分类
 * @constructor jack
 * */
export const saveProjectServiceCate = (data_json) => qspost('/Index/Service/saveProjectServiceCate', {data_json})





/*
 * 被服务人员列表导出
 * @constructor jack
 * */
export const exportServedPeople = (name, phone, xiangmu_id, xiaoqu_id, lou_id, men_id, hu_id) => qspostfile('/Index/Export/exportServedPeople', {
  name,
  phone,
  xiangmu_id,
  xiaoqu_id,
  lou_id,
  men_id,
  hu_id
})

/*
 * 被服务人员明细导出
 * @constructor jack
 * */
export const exportServedPeopleDetail = (jumin_id) => qspostfile('/Index/Export/exportServedPeopleDetail', {jumin_id})

/*
 * 志愿者队长/队员导出
 * @constructor jack
 * */
export const exportWuyeguanjiaList = (name, phone, power) => qspostfile('/Index/Export/exportWuyeguanjiaList', {
  name,
  phone,
  power
})

/*
 * 志愿者队长/队员明细导出
 * @constructor jack
 * */
export const exportWuyeguanjiaDetail = (id) => qspostfile('/Index/Export/exportWuyeguanjiaDetail', {id})


/*
 * 双暖服务队列表
 * @constructor jack
 * */
export const getServiceTeamList = (keyword, page, pageSize) => qspost('/Index/Service/getServiceTeamList', {
  name, page, pageSize
})

/*
 * 删除双暖服务队
 * @constructor jack
 * */
export const delServiceTeam = (id) => qspost('/Index/Service/delServiceTeam', {id})


/*
 * 删除双暖服务队
 * @constructor jack
 * */
export const getServiceTeamDetail = (id) => qspost('/Index/Service/getServiceTeamDetail', {id})



/*
 * 创建/编辑双暖服务队
 * @constructor jack
 * */
export const addServiceTeam = (name,type, xiaoqu_id_str, guanjia_id, admin_id_str, id) => qspost('/Index/Service/addServiceTeam', {
  name,
  type,
  xiaoqu_id_str,
  guanjia_id,
  admin_id_str,
  id
})
/*
 * 创建/编辑双暖服务队
 * @constructor jack
 * */
export const addNewServiceTeam = (name,xiangmu_id,type, xiaoqu_id_str, guanjia_id, admin_id_str, id) => qspost('/Index/Newservice/addServiceTeam', {
  name,
  xiangmu_id,
  type,
  xiaoqu_id_str,
  guanjia_id,
  admin_id_str,
  id
})



/*
 * 服务队建设数据
 * @constructor jack
 * */
export const serviceTotalData = () => qspost('/Index/Datascreen/serviceTotalData', {})


/*
 * 服务队建设数据
 * @constructor jack
 * */
export const serviceTeamData = (year,xian,xiaoqu) => qspost('/Index/Datascreen/serviceTeamData', {year,xian,xiaoqu})

/*
 * 服务队员发展数据
 * @constructor jack
 * */
export const serviceTeamMemberData = (keyword) => qspost('/Index/Datascreen/serviceTeamMemberData', {keyword})

/*
 * 志愿服务排名
 * @constructor jack
 * */
export const zhiyuanServiceRanking = (keyword1, order1, keyword2, order2, keyword3, order3) => qspost('/Index/Datascreen/zhiyuanServiceRanking', {  keyword1, order1, keyword2, order2, keyword3, order3})

/*
 * 服务实时数据
 * @constructor jack
 * */
export const serviceRealTimeData = () => qspost('/Index/Datascreen/serviceRealTimeData', {})

/*
 * 手机页面数据1
 * @constructor jack
 * */
export const phoneDateOne = () => qspost('/Index/Datascreen/phoneDateOne', {})

/*
 * 手机页面数据2
 * @constructor jack
 * */
export const phoneDateTwo = () => qspost('/Index/Datascreen/phoneDateTwo', {})
